/** Canonical public marketing origin (production). */
export const VISIME_PUBLIC_ORIGIN = 'https://visime.com';

export const DEFAULT_OG_IMAGE_PATH = '/logo512.png';

export const MARKETING_INDEX_PATHS = [
  '/landing',
  '/waiting-list',
  '/support',
  '/impressum',
  '/datenschutz',
  '/nutzungsbedingungen',
  '/cookie-richtlinie',
  '/presentation',
] as const;

export function defaultOgImageUrl(): string {
  const base = VISIME_PUBLIC_ORIGIN.replace(/\/$/, '');
  return `${base}${DEFAULT_OG_IMAGE_PATH}`;
}
